<section *ngIf="assinaturas.length" class="card">
  <div class="topo">
    <span class="eyebrow">CartãoSiM · pendência</span>
    <span class="selo">{{ linhas.length === 1 ? 'Assinatura cancelada' : linhas.length + ' assinaturas canceladas' }}</span>
  </div>
  <div class="resumo">
    <p class="titulo">Assinaturas</p>
    <span class="sub">{{ linhas.length }} {{ linhas.length === 1 ? 'cancelada' : 'canceladas' }} · {{ totalAbertas }} {{ totalAbertas === 1 ? 'fatura' : 'faturas' }} em aberto</span>
  </div>
  <p class="nota">Fatura em aberto de assinatura cancelada bloqueia a adesão a um novo plano. {{ naPausa ? '' : 'O atendimento de hoje segue normalmente. ' }}Clique numa assinatura para ver as parcelas.</p>

  <div *ngFor="let l of linhas; trackBy: porAssinatura" class="ass" [class.aberta]="abertas.has(l.subscriptionId)">
    <button type="button" class="linha" [attr.aria-expanded]="abertas.has(l.subscriptionId)" (click)="alternar(l.subscriptionId)">
      <span class="kv"><small>Plano</small><b>{{ l.plano }}</b></span>
      <span class="kv"><small>Adesão</small><b>{{ l.adesao | date: 'dd/MM/yyyy' }}</b></span>
      <span class="pill" [class.pill-vazia]="!l.faturasAbertas">{{ l.faturasAbertas }} - {{ l.faturasAbertas === 1 ? 'Fatura pendente' : 'Faturas pendentes' }}</span>
      <span class="status">Cancelado</span>
      <svg class="seta" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>

    <div class="detalhe" [hidden]="!abertas.has(l.subscriptionId)">
      <!-- Sempre montado (só escondido): o painel reporta temPendencia mesmo com a linha fechada -->
      <app-pendencia-sim *ngIf="l.cobravel as a" [style.display]="semNada.has(a.subscriptionId) ? 'none' : null"
                         [personId]="personId" [subscriptionId]="a.subscriptionId" [pendentesNaAssinatura]="a.faturasPendentes"
                         [outrasPendenciasCancelada]="outras(a)"
                         [clinicId]="clinicId" [cpf]="cpf" [guiche]="guiche" [procedimentos]="procedimentos" [naPausa]="naPausa"
                         (temPendencia)="onTemPendencia(a.subscriptionId, $event)" (regularizado)="onRegularizado()"></app-pendencia-sim>
      <p *ngIf="l.cobravel && semNada.has(l.subscriptionId)" class="aviso aviso-ambar">
        Nada para regularizar aqui (sem permissão para gerar fatura). Abra um ticket para o financeiro.
      </p>

      <ng-container *ngIf="l.bloqueios.length">
        <span class="det-tit">{{ l.cobravel ? 'Também em aberto' : 'Parcelas em aberto' }}</span>
        <div class="parcelas">
          <div *ngFor="let b of l.bloqueios" class="parcela">
            <span class="parcela-texto"><b>{{ rotulo(b) }}</b><small>Vencimento {{ b.vencimento }}</small></span>
            <b class="valor">{{ b.valor | brl }}</b>
          </div>
        </div>
        <p class="aviso aviso-ambar">{{ l.bloqueios.length === 1 ? 'Esta fatura não se regulariza' : 'Estas faturas não se regularizam' }} pela Fila. Abra um ticket para o financeiro.</p>
      </ng-container>

      <p *ngIf="!l.cobravel && !l.bloqueios.length" class="vazio">
        {{ l.faturasAbertas ? 'Fatura em aberto que não se regulariza pela Fila. Abra um ticket para o financeiro.' : 'Nenhuma fatura em aberto nesta assinatura.' }}
      </p>
    </div>
  </div>
</section>
